class NomInUseCard extends HTMLElement {
  constructor() {
    super();
    this.handleSoundClick = this.handleSoundClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleBadgeOpen = this.handleBadgeOpen.bind(this);
  }

  connectedCallback() {
    this.video = this.querySelector('.nom-card__video');
    this.soundBtn = this.querySelector('.nom-card__sound-toggle');
    this.soundOn = this.querySelector('.nom-card__sound-on');
    this.soundOff = this.querySelector('.nom-card__sound-off');
    this.closeBtn = this.querySelector('.nom-card__close');
    this.saleBox = this.querySelector('.nom-card__sale-box');
    this.countBadge = this.querySelector('.nom-card__badge--count');

    if (this.soundBtn && this.video) {
      this.soundBtn.addEventListener('click', this.handleSoundClick);
    }

    if (this.closeBtn && this.saleBox) {
      this.closeBtn.addEventListener('click', this.handleCloseClick);
    }

    if (this.countBadge && this.saleBox) {
      this.countBadge.addEventListener('click', this.handleBadgeOpen);
      this.countBadge.addEventListener('keydown', this.handleBadgeOpen);
    }
  }

  disconnectedCallback() {
    if (this.soundBtn) this.soundBtn.removeEventListener('click', this.handleSoundClick);
    if (this.closeBtn) this.closeBtn.removeEventListener('click', this.handleCloseClick);
    if (this.countBadge) {
      this.countBadge.removeEventListener('click', this.handleBadgeOpen);
      this.countBadge.removeEventListener('keydown', this.handleBadgeOpen);
    }
  }

  handleSoundClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.video) return;
    this.video.muted = !this.video.muted;
    const unmuted = !this.video.muted;
    this.soundBtn.setAttribute('aria-pressed', String(unmuted));
    if (this.soundOn) this.soundOn.hidden = !unmuted;
    if (this.soundOff) this.soundOff.hidden = unmuted;

    if (unmuted) {
      const playPromise = this.video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          this.video.muted = true;
          this.soundBtn.setAttribute('aria-pressed', 'false');
          if (this.soundOn) this.soundOn.hidden = true;
          if (this.soundOff) this.soundOff.hidden = false;
        });
      }
    }
  }

  handleCloseClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.saleBox) {
      this.saleBox.classList.add('is-hidden');
      this.saleBox.classList.remove('is-open');
    }
  }

  handleBadgeOpen(event) {
    // Toggle the tagged-products box. On mobile the box starts closed (CSS) and
    // `is-open` reveals it; on desktop/grid `is-hidden` hides a box the user
    // closed. A second click on the badge closes an open box again.
    // On keydown only react to Enter / Space.
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (!this.saleBox) return;
    const isOpen = this.saleBox.classList.contains('is-open') && !this.saleBox.classList.contains('is-hidden');
    if (isOpen) {
      this.saleBox.classList.remove('is-open');
      this.saleBox.classList.add('is-hidden');
    } else {
      this.saleBox.classList.remove('is-hidden');
      this.saleBox.classList.add('is-open');
    }
  }
}

if (!customElements.get('nom-in-use-card')) {
  customElements.define('nom-in-use-card', NomInUseCard);
}
